import { ListLayout } from '@ingrid/luterkort-react';

import { useTranslatedFormLabel } from '../hooks';
import { Schema } from '../queries';

interface Props {
  schema: Schema;
  path?: string;
}

interface ArrayItemProps {
  value: string;
  index: number;
  path?: string;
}

export function ArrayItem({ value, index, path = '' }: ArrayItemProps) {
  const label = useTranslatedFormLabel({ path, options: { index: index + 1 } });

  return (
    <ListLayout.Stack>
      <ListLayout.SecondaryText>{label}</ListLayout.SecondaryText>
      <ListLayout.PrimaryText>{value ? value : '-'}</ListLayout.PrimaryText>
    </ListLayout.Stack>
  );
}

export function SchemaDisplayArray({ schema, path = '' }: Props) {
  if (schema.type !== 'array') {
    return null;
  }

  return (
    <ListLayout.Stack>
      <ListLayout.Column>
        {schema.value?.map((v, index) => (
          <ArrayItem value={v} path={path} index={index} key={index} />
        ))}
      </ListLayout.Column>
    </ListLayout.Stack>
  );
}
